export const run = <T>(statement: () => T) => statement();
